import React from 'react'

import types from './types.json'
import publishImg from '../../images/png/landing/capability/publishModal.png'
import formsImg from '../../images/png/landing/capability/forms.png'
import graphsImg from '../../images/png/landing/capability/graphs.png'
import servicesImg from '../../images/png/landing/capability/services.png'

const CapabilitySection = ({ activeType = null, currentImages = null, t }) =>
    activeType.showCapability ? (
        <div className={`capability-section ${activeType.previews.length ? '' : 'capability-section__no-margin'}`}>
            <h3>{t(activeType.texts.capabilities.header)}</h3>
            <ul>
                <li>
                    {currentImages.capability ? <img src={currentImages.capability} alt="editor img" /> : null}
                    <div className="capability-section__box">
                        <div className="capability-section__content">
                            <h4>{t(activeType.texts.capabilities.items[0])}</h4>
                            <article>{t(types.capabilityTexts[activeType.texts.capabilities.items[0]])}</article>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="capability-section__box">
                        <div className="capability-section__content">
                            <h4>{t(activeType.texts.capabilities.items[1])}</h4>
                            <article>{t(types.capabilityTexts[activeType.texts.capabilities.items[1]])}</article>
                        </div>
                        <div className="capability-section__example-link">
                            https://interacty.me/projects/<span>oscars2020</span>
                        </div>
                    </div>
                    <img src={publishImg} alt="publish img" />
                </li>
                <li>
                    {activeType.texts.capabilities.items[2] === 'Gather leads' ? (
                        <img src={formsImg} alt="forms img" />
                    ) : (
                        <img className="capability-section__img-with-shadow" src={graphsImg} alt="graphs img" />
                    )}
                    <div className="capability-section__box">
                        <div className="capability-section__content">
                            <h4>{t(activeType.texts.capabilities.items[2])}</h4>
                            <article>{t(types.capabilityTexts[activeType.texts.capabilities.items[2]])}</article>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="capability-section__box">
                        <div className="capability-section__content">
                            <h4>{t(activeType.texts.capabilities.items[3])}</h4>
                            <article>{t(types.capabilityTexts[activeType.texts.capabilities.items[3]])}</article>
                        </div>
                    </div>
                    <img src={servicesImg} alt="services img" />
                </li>
            </ul>
        </div>
    ) : null

export default CapabilitySection
